import { render, staticRenderFns } from "./EditFabricOrders.vue?vue&type=template&id=3a840da4&scoped=true"
import script from "./EditFabricOrders.vue?vue&type=script&lang=js"
export * from "./EditFabricOrders.vue?vue&type=script&lang=js"
import style0 from "./EditFabricOrders.vue?vue&type=style&index=0&id=3a840da4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a840da4",
  null
  
)

export default component.exports